import { useHistory } from 'react-router-dom';
import React, { useState } from 'react';
import { Row, Col, Typography, Flex, Spin } from 'antd';
import { color } from '../../../../../resources/color';
import { ROUTES_PATH } from '../../../../../resources/routes-name';
import { Icon } from '../../../../../resources/icon';
import { boxStyle, loadingOverlayStyle } from './styles/styles';

const { Text } = Typography;

export const WarrantyAddCard = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const handleWarrantyClick = () => {
    setLoading(true);

    setTimeout(() => {
      history.push(ROUTES_PATH.ROUTE_REGISTER.PATH);
    }, 500);
  };

  return (
    <>
      {loading && (
        <div style={loadingOverlayStyle}>
          <Spin size="large" tip="กำลังโหลด..." />
        </div>
      )}
      <Row>
        <Col span={24}>
          <Flex style={{ width: '100%' }} justify={'center'} align={'center'}>
            <Flex
              vertical={true}
              style={boxStyle}
              justify={'center'}
              align={'center'}
              onClick={handleWarrantyClick}
            >
              <Icon.add style={{ width: '30px', height: '30px', color: color.yellowWhy }} />
              <Text strong>ลงทะเบียนสินค้าเพิ่ม</Text>
            </Flex>
          </Flex>
        </Col>
      </Row>
    </>
  );
};
